import { render } from "./trademark_edit.vue?vue&type=template&id=3aa3775e&scoped=true"
import script from "./trademark_edit.vue?vue&type=script&lang=js"
export * from "./trademark_edit.vue?vue&type=script&lang=js"

import "./trademark_edit.vue?vue&type=style&index=0&id=3aa3775e&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa3775e"]])

export default __exports__